import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=72d78c7a&scoped=true&"
import script from "./homework.vue?vue&type=script&lang=js&"
export * from "./homework.vue?vue&type=script&lang=js&"
import style0 from "./homework.vue?vue&type=style&index=0&id=72d78c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d78c7a",
  null
  
)

export default component.exports